import { SET_BONUS, RESET_BONUS } from '../constants/bonuses';

let initialState = {
    amount: 0,
    bonusType: '',
    expire: 0,
    gameId: '',
    initRollOver: 0,
    rollOver: 0,
    transType: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_BONUS:
            return {
                ...state,
                ...action.payload,
            };
        case RESET_BONUS:
            return {};
        default:
            return state;
    }
};

export default reducer;
